<template>
   <div class="addCompany">
       <div class="companyFlexClass">
           <div class="companyFlexClass1"><span class="keyred">*</span>公司名称</div>
           <div class="companyFlexClass2">
               <el-input
                       placeholder="请输入公司名称"
                       v-model="addCompanyInfo.name"
                       clearable
               >
               </el-input>
           </div>
       </div>
       <div class="companyFlexClass">
           <div class="companyFlexClass1">
               等级
           </div>
           <div class="companyFlexClass2">
               <el-radio v-model="addCompanyInfo.grade" label="NORMAL">普通</el-radio>
               <el-radio v-model="addCompanyInfo.grade" label="VIP">vip</el-radio>
           </div>
       </div>
       <div class="companyFlexClass">
           <div class="companyFlexClass1">公司邮箱后缀
               <el-popover
                       placement="top-start"
                       width="230"
                       trigger="hover"
               >
                   <span style="color: #F56C6C">客户主邮箱的后缀是企业邮箱后缀时，将被自动添加到该公司</span>

                   <span slot="reference" style="margin-left: 4px;">
                                        <i class="el-icon-warning-outline" style="font-size: 14px;color: #AAAAAA"></i>
                                    </span>
               </el-popover>
           </div>
           <div class="companyFlexClass2" >
               <el-input
                       placeholder="请输入公司邮箱后缀"
                       v-model="addCompanyInfo.mailSuffix"
                       clearable
               >
               </el-input>
           </div>
       </div>
       <div class="companyFlexClass">
           <div class="companyFlexClass1">公司联系人</div>
           <div class="companyFlexClass2" >
               <el-input
                       placeholder="请输入公司联系人姓名"
                       v-model="addCompanyInfo.contactPerson"
                       clearable
               >
               </el-input>
           </div>
       </div>
       <div class="companyFlexClass">
           <div class="companyFlexClass1">联系人电话</div>
           <div class="companyFlexClass2" >
               <el-input
                       placeholder="请输入公司联系人电话"
                       v-model="addCompanyInfo.contactPersonTel"
                       clearable
                       @blur="phoneClick(addCompanyInfo.contactPersonTel)"
               >
               </el-input>
           </div>
       </div>
       <div class="companyFlexClass">
           <div class="companyFlexClass1">联系人邮箱</div>
           <div class="companyFlexClass2" >
               <el-input
                       placeholder="请输入联系人邮箱"
                       v-model="addCompanyInfo.contactPersonMail"
                       clearable
                       @blur="emailClick(addCompanyInfo.contactPersonMail)"
               >
               </el-input>
           </div>
       </div>
       <div class="companyFlexClass">
           <div class="companyFlexClass1">负责组</div>
           <div class="companyFlexClass2" >
               <el-select v-model="addCompanyInfo.groupId"
                          clearable
                          placeholder="请选择或者搜索负责组"
                          style="width: 100%;position: relative"
                          @change="getAccountPerson"
               >
                   <div>
                       <el-input
                               placeholder="可搜索"
                               clearable
                               v-model="companyGroupSelect"
                               style="position: absolute;top: 0;z-index: 9"
                               @input="changeSelectCompanyGroup"
                       >
                       </el-input>
                   </div>
                   <div v-if="companySelectGroupList.length===0">
                       <el-option value="" style="height: 40px"></el-option>
                   </div>
                   <div style="margin-top: 40px">
                       <el-option
                               v-for="item in companySelectGroupList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"
                       >
                       </el-option>
                   </div>

               </el-select>
           </div>
       </div>
       <div class="companyFlexClass">
           <div class="companyFlexClass1">负责人</div>
           <div class="companyFlexClass2" >
               <el-select v-model="addCompanyInfo.principalId"
                          clearable
                          placeholder="请选择或者搜索负责人"
                          style="width: 100%"
               >
                   <div>
                       <el-input
                               placeholder="可搜索"
                               clearable
                               v-model="companyPersonSelect"
                               style="position: absolute;top: 0;z-index: 9"
                               @input="changeSelectCompanyPerson"
                       >
                       </el-input>
                   </div>
                   <div v-if="companySelectPerson.length===0">
                       <el-option value="" style="height: 40px"></el-option>
                   </div>
                   <div style="margin-top: 40px">
                       <el-option
                               v-for="item in companySelectPerson"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                       </el-option>
                   </div>

               </el-select>
           </div>
       </div>
       <div style="display: flex;padding: 6px 0 0 0">
           <div style="flex: 0.2 0.2 0;height: 40px;line-height: 40px;">描述</div>
           <div style="flex: 0.8 0.8 0">
               <el-input
                       type="textarea"
                       :rows="2"
                       placeholder="对该公司的描述"
                       v-model="addCompanyInfo.description">
               </el-input>
           </div>
       </div>
   </div>
</template>

<script>
    export default {
        name: "addCompany",
        data(){
            return{
                companyDialogFormVisible:false,
                formLabelWidth: '60px',
                clueCompanyValue:'',
                addCompanyInfo:{
                    contactPerson: '',
                    contactPersonMail: '',
                    contactPersonTel: '',
                    description:'',
                    groupId: '',
                    name: '',
                    principalId: '',
                    grade: 'NORMAL',
                    mailSuffix: '',
                },
                accountPerson:{
                    list:[]
                },
                accountGroup:{
                    list:[]
                },
                companySelectGroupList:[],
                companySelectPerson:[],
                companyGroupSelect:'',
                companyPersonSelect:''
            }
        },
        props:['leadsForm'],
        mounted() {
            this.$nextTick(()=>{
                this.getAccountGroup()
                this.getAccountPerson()
            })
        },
        methods:{
            emailClick(mail){
                const reg= /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                if(mail!=='')
                {
                    if(!reg.test(mail))
                    {
                        this.$message('请输入有效的邮箱')
                        return false
                    }
                    else {
                        return true
                    }
                }
                else {
                    return true
                }

            },
            phoneClick(mobile){
                const phone=/^[1][3,4,5,7,8][0-9]{9}$/
                if(mobile!=='')
                {
                    if(!phone.test(mobile))
                    {
                        this.$message('请输入有效的电话号码')
                        return false
                    }
                    else {
                        return true
                    }
                }
                else {
                    return  true
                }

            },
            clueAddCompany(){
                this.addCompanyInfo={
                    contactPerson: '',
                    contactPersonMail: '',
                    contactPersonTel: '',
                    description:'',
                    groupId: '',
                    name: '',
                    principalId: '',
                    grade: 'NORMAL',
                    mailSuffix: '',
                }
                this.companyDialogFormVisible=true
            },
            //获取负责组下拉列表值
            getAccountGroup(){
                this.$http.get('/api/account/group').then(res=>{
                    this.accountGroup.list=res.data.data
                    this.companySelectGroupList=res.data.data
                })
            },
            //获取负责人的下拉列表值
            getAccountPerson(){
                if(this.addCompanyInfo.groupId!=='')
                {
                    this.$http.get('/api/account/principal?groupId='+this.addCompanyInfo.groupId).then(res=>{
                        this.accountPerson.list=res.data.data
                        this.companySelectPerson=res.data.data
                    })
                }
                else
                {
                    this.$http.get('/api/account/principal?groupId=%20').then(res=>{
                        this.accountPerson.list=res.data.data
                        this.companySelectPerson=res.data.data
                    })
                }


            },
            changeSelectCompanyGroup(value){
                if(value!=='')
                {
                    let selectCompanyGroup=[]
                    this.accountGroup.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompanyGroup.push(item)
                        }
                    })
                    this.companySelectGroupList=selectCompanyGroup

                }
                else
                {
                    this.companySelectGroupList=this.accountGroup.list
                }
            },
            changeSelectCompanyPerson(value){
                if(value!=='')
                {
                    let selectCompanyPerson=[]
                    this.accountPerson.list.forEach((item) => {
                        if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
                            selectCompanyPerson.push(item)
                        }
                    })
                    this.companySelectPerson=selectCompanyPerson

                }
                else
                {
                    this.companySelectPerson=this.accountPerson.list
                }

            }
        }
    }
</script>

<style scoped lang="less">

</style>